function Netherlands({ dimensions }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1754)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M16 0C9.12061 0 3.25593 4.342 0.995239 10.4348H31.0049C28.7442 4.342 22.8795 0 16 0Z" fill="#A2001D"/>
  <path d="M16 32.0002C22.8795 32.0002 28.7442 27.6582 31.0049 21.5654H0.995239C3.25593 27.6582 9.12061 32.0002 16 32.0002Z" fill="#0052B4"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Netherlands;
